import { Component, Input } from '@angular/core';
import { DcrKeyValue } from '@ddt-web/config';

@Component({
	selector: 'ac-number-badge',
	templateUrl: './number-badge.component.html',
	styleUrls: ['./number-badge.component.scss']
})
export class NumberBadgeComponent {

	@Input() public size: 'medium' | 'large' = 'large';
	@Input() public color: 'red' | 'yellow' | 'green' | 'grey' = 'red';
	@Input() public number: number;
	@Input() public style: any = {};
	@Input() public subtitle: DcrKeyValue = {
		dcrKey: 'BADGE_SUBTITLE',
		dcrValue: 'FUNDS'
	};
	@Input() public isLoading?: boolean;
}
